// extracted by mini-css-extract-plugin
export default {"wrapper":"JobItem_wrapper__8fyej","top":"JobItem_top__POoEC","bottom":"JobItem_bottom__G0PW6","desk":"JobItem_desk__g50rd"};